import React from 'react';
import AuthCallback from '../../components/auth/AuthCallback';

const AuthCallbackPage: React.FC = () => {
  return <AuthCallback />;
};

export default AuthCallbackPage;
